import { Popconfirm, Switch, Tooltip, notification } from 'antd';
import Card from 'antd/lib/card';
import Form from 'antd/lib/form';
import Table, { ColumnProps } from 'antd/lib/table';
import TreeSelectDropdown from 'components/TreeSelect/TreeSelect';
import { generalLanguageKeys } from 'config/consts';
import { crudService, formService } from 'core/services';
import { renderMasterIndex } from 'helpers/ant-design/table';
import { FileModel, FileTemplate } from 'models/FileTemplate';
import { FileTemplateFilter } from 'models/FileTemplateFilter';
import { FileTemplateInput } from 'models/FileTemplateInput';
import { MenuReport } from 'models/MenuReport';
import { Organization } from 'models/Organization';
import { OrganizationFilter } from 'models/OrganizationFilter';
import React, { Dispatch, RefObject, SetStateAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTableProps } from 'react3l';
import { Modal } from 'reactstrap';
import { tableService } from 'services';
import nameof from 'ts-nameof.macro';
import { menuReportRepository } from 'views/MenuReportView/MenuReportRepository';
import useFileTemplateInputModalHook from './FileTemplateInputModalHook';
import { limitWord } from 'core/helpers/string';
import { Status } from 'models/Status';
export interface FileTemplateTableProps
  extends ContentTableProps<MenuReport, FileTemplate> {
  menuReport?: MenuReport;
  filter?: FileTemplateFilter;
  setFilter?: Dispatch<SetStateAction<FileTemplateFilter>>;
  isPreview?: boolean;
}
const { Item: FormItem } = Form;

function FileTemplateTable(props: FileTemplateTableProps) {
  const [translate] = useTranslation();
  const { model, setModel, isPreview } = props;

  const [
    fileTemplates,
    setFileTemplates,
    handleAdd,
    handleDelete,
  ] = crudService.useContentTable<MenuReport, FileTemplate>(
    model,
    setModel,
    nameof(model.fileTemplates),
  );

  const [
    handleChangeListSimpleField,
    handleChangeObjectField,
    ,
    handleChangeField,
  ] = crudService.useListChangeHandlers<FileTemplate>(
    fileTemplates,
    setFileTemplates,
  );
  const handleChanegBoolField = React.useCallback(
    (field: string, index: number) => checked => {
      if (checked) {
        fileTemplates[index][field] = 1;
      } else {
        fileTemplates[index][field] = 0;
      }
      setFileTemplates([...fileTemplates]);
    },
    [fileTemplates, setFileTemplates],
  );

  const [fileTemplateFilter, setFileTemplateFilter] = React.useState<
    FileTemplateFilter
  >(new FileTemplateFilter());
  const [organizationFilter, setOrganizationFilter] = React.useState<
    OrganizationFilter
  >(new OrganizationFilter());

  const [
    dataSource,
    pagination,
    ,
    handleTableChange,
  ] = tableService.useLocalTable(
    fileTemplates,
    fileTemplateFilter,
    setFileTemplateFilter,
  );
  const handleUpdateFileTemplateInput = React.useCallback(
    (fileTemplateInputs: FileTemplateInput[], fileTemplate) => {
      const index = fileTemplates
        .map(item => item.key)
        .indexOf(fileTemplate.key);
      handleChangeField('fileTemplateInputs', index, fileTemplateInputs);
    },
    [fileTemplates, handleChangeField],
  );
  const {
    handleOpenModal,
    handleSaveModal,
    handleCloseModal,
    handleAddFileTemplateInput,
    handleBulkDeleteFileTemplateInput,
    rowSelectionFileTemplateInput,
    canBulkActionFileTemplateInput,
    fileTemplateInputColumns,
    fileTemplateInputsInternal,
    visible,
  } = useFileTemplateInputModalHook(
    handleUpdateFileTemplateInput,
    translate,
    isPreview,
    model.id,
  );
  const fileRef: RefObject<HTMLInputElement> = React.useRef<HTMLInputElement>();

  const handleChangeFile = React.useCallback(
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (files && files.length > 0) {
        let check = false;
        let totalSize = 0;
        Array.from(files).forEach(file => {
          totalSize = totalSize + file.size;
          if (totalSize > 25000000) {
            notification.error({
              message:
                'Tổng dung lượng tất cả file đính kèm vượt quá dung lượng cho phép.',
              description: 'Tổng dung lượng File được tải lên phải dưới 25MB',
            });
            check = true;
          }
        });
        if (check) return null;
        menuReportRepository.upload(files[0]).then(
          (res: any) => {
            if (res) {
              const newModel = { ...model };
              const newValues = [...model.fileTemplates];
              newValues[index].fileId = res.id;
              newValues[index].file = res;
              newModel.fileTemplates = [...newValues];
              setModel({ ...newModel });
            }
          },
          err => {
            // tslint:disable-next-line:no-console
            console.log('err', err);
          },
        );
      }
    },
    [model, setModel],
  );
  const handleRemoveFile = React.useCallback(
    (index: number) => {
      const newValues = [...model.fileTemplates];
      const newModel = { ...model };
      newValues[index].fileId = undefined;
      newValues[index].file = undefined;
      newModel.fileTemplates = [...newValues];
      setModel(newModel);
    },
    [model, setModel],
  );
  const handleCloneFileTemplate = React.useCallback(
    (index: number, fileTempalte: FileTemplate) => () => {
      const newFileTemplate = new FileTemplate();
      newFileTemplate.fileTemplateInputs =
        fileTempalte &&
        fileTempalte.fileTemplateInputs &&
        fileTempalte.fileTemplateInputs.length > 0
          ? [...fileTempalte.fileTemplateInputs]
          : [];
      newFileTemplate.selfDefineInputId = 1;
      fileTemplates.splice(index + 1, 0, newFileTemplate);
      setFileTemplates([...fileTemplates]);
    },
    [fileTemplates, setFileTemplates],
  );
  const actionColumns: ColumnProps<FileTemplate>[] = React.useMemo(
    () => [
      {
        title: translate(generalLanguageKeys.actions.label),
        key: nameof('action'),
        dataIndex: nameof('action'),
        width: 80,
        align: 'center',
        render(...params: [string, FileTemplate, number]) {
          if (!isPreview)
            return (
              <div className="d-flex w-100 justify-content-center button-action-table">
                <Popconfirm
                  title={translate('general.delete.content')}
                  onConfirm={handleDelete(
                    params[2] +
                      (pagination?.current - 1) * pagination?.pageSize,
                  )}
                  okText={translate('general.actions.delete')}
                  cancelText={translate('general.actions.close')}
                >
                  <i className="tio-delete_outlined mr-2" color="red" />
                </Popconfirm>
                <i
                  className="tio-files_labeled_outlined mr-2"
                  onClick={handleCloneFileTemplate(
                    params[2] +
                      (pagination?.current - 1) * pagination?.pageSize,
                    params[1],
                  )}
                />
              </div>
            );
        },
      },
    ],
    [handleCloneFileTemplate, handleDelete, isPreview, pagination, translate],
  );
  const detailColumns: ColumnProps<FileTemplate>[] = React.useMemo(
    () => [
      {
        title: translate(generalLanguageKeys.columns.index),
        key: nameof(generalLanguageKeys.columns.index),
        width: 80,
        render: renderMasterIndex<FileTemplate>(pagination),
      },

      {
        title: translate('menuReports.organization'),
        key: 'organization',
        dataIndex: 'organization',
        width: 300,
        render(...params: [Organization, FileTemplate, number]) {
          if (!isPreview)
            return (
              <FormItem
                validateStatus={formService.getValidationStatus<FileTemplate>(
                  params[1].errors,
                  nameof(params[1].organizationId),
                )}
                help={params[1].errors?.organizationId}
                className="custom-form"
              >
                <TreeSelectDropdown
                  defaultValue={params[1]?.organizationId}
                  value={
                    params[1]?.organizationId === 0
                      ? null
                      : params[1]?.organizationId
                  }
                  mode="single"
                  onChange={handleChangeObjectField(
                    'organization',
                    params[2] +
                      (pagination?.current - 1) * pagination?.pageSize,
                  )}
                  modelFilter={organizationFilter}
                  setModelFilter={setOrganizationFilter}
                  getList={menuReportRepository.singleListOrganization}
                  searchField={nameof(organizationFilter.id)}
                  placeholder={translate(
                    'menuReports.placeholder.organization',
                  )}
                />
              </FormItem>
            );
          else return <>{params[0]?.name}</>;
        },
      },

      {
        title: translate('menuReports.name'),
        key: nameof(dataSource[0].name),
        dataIndex: nameof(dataSource[0].name),
        width: 300,
        render(name: string, content: FileTemplate, index: number) {
          if (!isPreview)
            return (
              <FormItem
                validateStatus={formService.getValidationStatus<FileTemplate>(
                  content.errors,
                  nameof(content.name),
                )}
                help={content.errors?.name}
                className="custom-form"
              >
                <input
                  type="text"
                  defaultValue={name}
                  className="form-control form-control-sm"
                  onChange={handleChangeListSimpleField(
                    'name',
                    index + (pagination?.current - 1) * pagination?.pageSize,
                  )}
                  placeholder={translate('menuReports.placeholder.name')}
                />
              </FormItem>
            );
          return <>{name}</>;
        },
      },
      {
        title: translate('menuReports.file'),
        key: nameof(dataSource[0].file),
        dataIndex: nameof(dataSource[0].file),
        width: 400,
        render(...params: [FileModel, FileTemplate, number]) {
          if (!isPreview)
            return (
              <>
                <FormItem
                  validateStatus={formService.getValidationStatus<FileTemplate>(
                    params[1].errors,
                    nameof(params[1].fileId),
                  )}
                  help={params[1].errors?.fileId}
                  className="custom-form"
                >
                  <button
                    className=" btn btn-sm btn-primary "
                    onClick={() => {
                      document
                        .getElementById(
                          `file-template-${params[2] +
                            (pagination?.current - 1) * pagination?.pageSize}`,
                        )
                        .click();
                    }}
                  >
                    <i className="tio-attachment_diagonal"></i> Đính kèm
                  </button>

                  <input
                    type="file"
                    style={{ display: 'none' }}
                    ref={fileRef}
                    id={`file-template-${params[2] +
                      (pagination?.current - 1) * pagination?.pageSize}`}
                    onChange={handleChangeFile(
                      params[2] +
                        (pagination?.current - 1) * pagination?.pageSize,
                    )}
                  />

                  {params[0]?.name.length > 20 ? (
                    <Tooltip title={params[0]?.name}>
                      <a href={params[0]?.path} className="ml-1">
                        {limitWord(params[0]?.name, 20)}
                      </a>
                    </Tooltip>
                  ) : (
                    <a href={params[0]?.path} className="ml-1">
                      {params[0]?.name}
                    </a>
                  )}

                  {params[0]?.name && (
                    <i
                      className="tio-clear mt-1 ml-1 icon-delete"
                      onClick={() =>
                        handleRemoveFile(
                          params[2] +
                            (pagination?.current - 1) * pagination?.pageSize,
                        )
                      }
                      color="#D30000"
                    />
                  )}
                </FormItem>
              </>
            );
          else {
            return (
              <>
                {params[0]?.name.length > 30 ? (
                  <Tooltip title={params[0]?.name}>
                    <a href={params[0].url}>{limitWord(params[0]?.name, 30)}</a>
                  </Tooltip>
                ) : (
                  <a href={params[0].url}>{params[0]?.name}</a>
                )}
              </>
            );
          }
        },
      },
      {
        title: translate('menuReports.selfDefineInput'),
        key: nameof(dataSource[0].selfDefineInputId),
        dataIndex: nameof(dataSource[0].selfDefineInput),
        width: 200,
        render(...params: [number, FileTemplate, number]) {
          if (!isPreview)
            return (
              <FormItem
                validateStatus={formService.getValidationStatus<FileTemplate>(
                  params[1].errors,
                  nameof(params[1].selfDefineInputId),
                )}
                help={params[1].errors?.selfDefineInputId}
                className="custom-form"
              >
                <Switch
                  checked={params[1].selfDefineInputId === 1 ? true : false}
                  onChange={handleChanegBoolField(
                    'selfDefineInputId',
                    params[2] +
                      (pagination?.current - 1) * pagination?.pageSize,
                  )}
                />
              </FormItem>
            );
          else
            return (
              <Switch
                defaultChecked={
                  params[1].selfDefineInputId === 1 ? true : false
                }
                disabled
              />
            );
        },
      },
      {
        title: translate('menuReports.selfDefineInput'),
        width: 160,
        key: nameof('selfDefineInput'),
        dataIndex: nameof('selfDefineInputId'),
        render(...params: [number, FileTemplate, number]) {
          if (params[1].selfDefineInputId === 1)
            return (
              <FormItem
                validateStatus={formService.getValidationStatus<FileTemplate>(
                  params[1].errors,
                  nameof(params[1].selfDefineInputId),
                )}
                help={params[1].errors?.selfDefineInputId}
                className="custom-form"
              >
                <div
                  onClick={() => {
                    handleOpenModal(params[1]);
                  }}
                  className="file-template-view"
                >
                  {'Click để xem'}
                </div>
              </FormItem>
            );
        },
      },
      {
        title: translate('menuReports.status'),
        key: nameof(dataSource[0].status),
        dataIndex: nameof(dataSource[0].status),
        align: 'center',
        width: 180,
        render(...params: [Status, FileTemplate, number]) {
          if (!isPreview)
            return (
              <FormItem
                validateStatus={formService.getValidationStatus<FileTemplate>(
                  params[1].errors,
                  nameof(params[1].status),
                )}
                help={params[1].errors?.status}
                className="custom-form"
              >
                <Switch
                  checked={params[1].statusId === 1 ? true : false}
                  onChange={handleChanegBoolField(
                    'statusId',
                    params[2] +
                      (pagination?.current - 1) * pagination?.pageSize,
                  )}
                  className="ml-5"
                />
              </FormItem>
            );
          else
            return (
              <div className={params[0]?.id === 1 ? 'active' : ''}>
                <i className="fa fa-check-circle d-flex justify-content-center"></i>
              </div>
            );
        },
      },
    ],
    [
      dataSource,
      handleChanegBoolField,
      handleChangeFile,
      handleChangeListSimpleField,
      handleChangeObjectField,
      handleOpenModal,
      handleRemoveFile,
      isPreview,
      organizationFilter,
      pagination,
      translate,
    ],
  );
  const columns = useMemo(() => {
    if (isPreview) return [...detailColumns];
    else return [...detailColumns, ...actionColumns];
  }, [actionColumns, detailColumns, isPreview]);

  const tableFooter = React.useCallback(
    () => (
      <>
        <button className="btn btn-link" onClick={handleAdd}>
          <i className="fa fa-plus mr-2" />
          {translate(generalLanguageKeys.actions.create)}
        </button>
      </>
    ),
    [handleAdd, translate],
  );

  return (
    <div>
      <Table
        key={'key'}
        pagination={pagination}
        dataSource={dataSource}
        columns={columns}
        onChange={handleTableChange}
        footer={!isPreview && tableFooter}
        className="table-content"
        scroll={{ x: 1000 }}
      />
      <Modal
        isOpen={visible}
        toggle={handleCloseModal}
        size="xl"
        backdrop="static"
        unmountOnClose={true}
      >
        <Card
          title={
            <>
              {translate('fileTemplateInputs.title')}
              <button
                className="btn btn-sm btn-outline-primary float-right mr-2 "
                onClick={handleCloseModal}
              >
                <i className="fa mr-2 fa-times-circle" />
                {translate(generalLanguageKeys.actions.cancel)}
              </button>
              {!isPreview && (
                <button
                  className="btn btn-sm btn-primary float-right mr-2"
                  onClick={handleSaveModal}
                >
                  <i className="fa mr-2 fa-save" />
                  {translate(generalLanguageKeys.actions.save)}
                </button>
              )}
            </>
          }
        >
          <div className="modal-content">
            <div className="mt-2">
              <div className="d-flex justify-content-end  mt-2">
                {canBulkActionFileTemplateInput && (
                  <button
                    className="btn btn-sm btn-danger mr-2"
                    onClick={handleBulkDeleteFileTemplateInput}
                  >
                    <i className="tio-delete_outlined mr-2" />
                    {translate('general.actions.delete')}
                  </button>
                )}
              </div>
              <div className="w-100 mt-2">
                <Table
                  rowKey={nameof('key')}
                  rowSelection={!isPreview && rowSelectionFileTemplateInput}
                  columns={fileTemplateInputColumns}
                  dataSource={fileTemplateInputsInternal}
                  scroll={{ y: 500 }}
                  className="file-template-table"
                  pagination={false}
                  footer={() => (
                    <>
                      {!isPreview && (
                        <button
                          className="btn btn-link"
                          onClick={handleAddFileTemplateInput}
                        >
                          <i className="fa fa-plus mr-2" />
                          {translate('general.actions.add')}
                        </button>
                      )}
                    </>
                  )}
                />
              </div>
            </div>
          </div>
        </Card>
      </Modal>
    </div>
  );
}
export default FileTemplateTable;
